export default __webpack_public_path__ + "static/media/schedularI.44c58c3d.svg";